import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from './store';

import {
    feedsInitFieldMap,
    feedsHydrate,
} from './modules/Feeds/actions';

import {
    loadSalesforceObjectFields,
    saveStore,
    getStore,
    metaStoreStatus,
    metaStoreForm,
    metaStoreFeedId,
    metaUpdateDupesHydrate,
} from './modules/Meta/actions';

import ErrorBoundary from './components/ErrorBoundary';
import FieldSettingsHead from './components/FieldSettingsHead';
import FieldMapList from './components/FieldMapList';

const $ = jQuery;
const { dispatch } = store;

class App extends React.Component {
    componentWillMount() {
        let $updateBtn = $('#gform-settings-save');
        $updateBtn.on('click', async e => {
            try {
                const resp = await saveStore();
                const { status, msg } = JSON.parse(resp);

                if (status != 'ok') {
                    e.preventDefault();
                    alert(msg);

                    return false;
                }
            } catch (e) {
                console.error(e);
            }
        });

        let $s = $('#salesforceObject');
        $s.on('change', e => {
            loadSalesforceObjectFields(e.target.value);
        });

        this.loadFeedData();

        dispatch(metaStoreStatus(this.props.status));
        dispatch(metaStoreForm(this.props.form));
        dispatch(metaStoreFeedId(this.props.feed_id));
    }

    async loadFeedData() {
        let $s = $('#salesforceObject');
        if ($s.val() != '') {
            loadSalesforceObjectFields($s.val());

            let ret = await getStore(this.props.form.id, this.props.feed_id, $s.val());

            if (ret.status == 'ok') {
                if (ret.data == null) {
                    dispatch(feedsInitFieldMap($s.val()));
                } else {
                    const feeds = JSON.parse(ret.data.feed) || {};
                    const update_dupes = JSON.parse(ret.data.update_dupes) || {};

                    dispatch(metaUpdateDupesHydrate(update_dupes));
                    dispatch(feedsHydrate({ feeds }));
                }
            } else {
                throw `Error: ${ret.msg}`;
            }
        }
    }

    render() {
        return (
            <Provider store={store}>
                <ErrorBoundary>
                    <FieldSettingsHead />
                    <FieldMapList />
                </ErrorBoundary>
            </Provider>
        );
    }
}

(function ($) {
    $(document).ready(function (e) {
        if (!viagf_settings[viagf_name_field]) {
            if ($('#tab_via-gravityforms-salesforce .feeds tbody tr').length >= 1) {
                $('#tab_via-gravityforms-salesforce #form_settings a.add-new-h2').hide();
            }
        }

        let app = document.getElementById('viagf_settings_app');

        if (app) {
            let feed_id = document.querySelector('input[name="gf_feed_id"]').value;
            render(<App form={window.viagf.form} feed_id={feed_id} status={viagf_settings[viagf_name_field]} />, app);
        }
    });
})(jQuery);
